import { useEffect, useRef, useState } from "react";

/**
 * Scroll-driven fill for the vertical process timeline. Returns
 * { sectionRef, progress } where progress is 0..1 as the section passes
 * through the viewport. rAF-throttled.
 */
const useProcessProgress = () => {
  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) {
      return undefined;
    }

    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = section.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (window.innerHeight * 0.6 - rect.top) / (rect.height * 0.82)));
      setProgress(p);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return { sectionRef, progress };
};

export default useProcessProgress;
